/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setQBProperty, setStoryProperty, updateOptionProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import EditableText from 'material/embeds/editabletext/editabletext';



/* ========== ~~~~~~~~~~ EDITABLE TEXT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId, optionId, isOption }) => ({
    type: embedsState.embedManagementState.contentStatus['contents'][contentId]['type'],
    isStory: embedsState.embedManagementState.contentStatus['contents'][contentId]['contentType'] === 'story', // do not pass question title for the option editing fields
    optionText: isOption ? embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['text'] : null,
    isCorrectOption: isOption ? embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['correctOption'] : null,
});

const mapDispatchToProps = dispatch => ({
    setQBProperty: (contentId, property, value) => dispatch(setQBProperty(contentId, property, value)),
    setStoryProperty: (contentId, property, value) => dispatch(setStoryProperty(contentId, property, value)),
    updateOptionProperty: (contentId, optionId, propertyName, value) => dispatch(updateOptionProperty(contentId, optionId, propertyName, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditableText);
